<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/dashboard" name="Dashboard" icon="ti-panel"/>
        <sidebar-link v-if="userAccess.indexOf('email-properties') !== -1" to="/email-properties" name="Email Properties" icon="ti-email"/>
        <sidebar-link v-if="userAccess.indexOf('heatmaps') !== -1" to="/heatmaps" name="Heatmaps" icon="ti-target"/>
        <sidebar-link v-if="userAccess.indexOf('assets') !== -1" to="/assets" name="Assets" icon="ti-gallery"/>
        <sidebar-link v-if="userAccess.indexOf('deleted-assets') !== -1" to="/deleted-assets" name="Deleted Assets" icon="ti-trash"/>
        <sidebar-link v-if="userAccess.indexOf('pages') !== -1" to="/pages" name="Pages" icon="ti-files"/>
        <sidebar-link v-if="userAccess.indexOf('navigation') !== -1" to="/navigation" name="Navigation" icon="ti-link"/>
        <sidebar-link v-if="userAccess.indexOf('live') !== -1" to="/live" name="Live" icon="ti-home"/>
        <sidebar-link v-if="userAccess.indexOf('users') !== -1" to="/users" name="Users" icon="ti-user"/>
        <sidebar-link v-if="userAccess.indexOf('settings') !== -1" to="/settings" name="Settings" icon="ti-settings"/>
      </template>
      <mobile-menu />
    </side-bar>
    <div class="main-panel">
      <top-navbar />
      <dashboard-content @click.native="toggleSidebar" />
      <content-footer />
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },

  computed: {
    userAccess () {
      return this.$store.getters.user.access ? this.$store.getters.user.access : []
    }
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}
</script>
